// Please do not use optional chaining (?.), nullish coalescing (??), or other ES2020+ features

import React from 'react';
import { Handle } from 'react-flow-renderer';

const IndividNode = ({ data }) => {
  const { title, triplets = {}, tag, rawId, showUidData = true } = data;
  // Use data.color if it exists, otherwise use default
  const color = data.color || '#3b82f6';

  const [hovered, setHovered] = React.useState(false);
  const selected = data.selected;
  const deletionMode = data.deletionMode;
  const onSelectToggle = data.onSelectToggle;

  // Show all triplets, not just filtered values
  const tripletEntries = Object.entries(triplets);

  return (
    <div
      style={{
        background: 'rgba(42, 48, 85, 0.8)',
        backdropFilter: 'blur(3px)',
        borderRadius: '6px',
        border: `2px dashed ${color}`,
        padding: '12px 16px',
        width: '180px',
        color: '#ffffff',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        position: 'relative',
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div style={{
        fontWeight: 500,
        marginBottom: '3px'
      }}>
        <span style={{ color: '#fff', fontWeight: 500, fontSize: '14px', marginRight: 8 }}>{title}</span>
      </div>
      {/* Box for rawId and tag */}
      {showUidData && (
        <div style={{
          background: 'rgba(0, 0, 0, 0.0)',
          borderRadius: '4px',
          padding: '4px 0',
          marginBottom: '8px',
          fontSize: '12px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <span style={{ color: '#aaa' }}>{rawId}</span>
          {tag && rawId && tag.toString() !== rawId.toString() ? <span style={{ color: '#aaa' }}>#{tag}</span> : null}
        </div>
      )}
      {/* Checkbox icon for deletion mode */}
      {deletionMode && (hovered || selected) && (
        <div
          style={{
            position: 'absolute',
            top: 4,
            right: 4,
            zIndex: 10,
            cursor: 'pointer',
            background: 'rgba(0,0,0,0.7)',
            borderRadius: '50%',
            padding: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onClick={e => {
            e.stopPropagation();
            if (onSelectToggle) onSelectToggle();
          }}
        >
          {selected ? (
            // Checked box SVG
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><rect x="2" y="2" width="14" height="14" rx="4" fill="#347CFF"/><path d="M5 9.5l3 3 5-5" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
          ) : (
            // Unchecked box SVG
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><rect x="2" y="2" width="14" height="14" rx="4" stroke="#347CFF" strokeWidth="2" fill="none"/></svg>
          )}
        </div>
      )}
      <Handle
        type="target"
        position="top"
        style={{
          background: color,
          width: '6px',
          height: '6px',
          border: 'none',
          borderRadius: '50%',
          top: '-3px'
        }}
      />
      {tripletEntries.length > 0 && (
        <ul style={{ paddingLeft: 0, margin: 0, marginBottom: 8 }}>
          {tripletEntries.map(([key, value], index) => {
            if (!value || value && !value.value) return null;
            return (
              <li key={index} style={{ fontSize: '12px', color: '#fff', marginBottom: 2 }}>
                <span style={{ color: '#ffffff99', fontWeight: 500 }}>{key}</span>
                <span style={{ color: '#ffffff99', marginLeft: 6 }}>:</span>
                <span style={{ color: '#fff', marginLeft: 6 }}>
                  {/* {value ? value.value : value.toString()} */}
                  {value && value.type === 'OBJECT' && value.value ? `→ ${value.value}` : (value && value.value ? value.value.toString() : value.toString())}
                </span>
              </li>
          )})}
        </ul>
      )}
      <Handle
        type="source"
        position="bottom"
        style={{
          background: color,
          width: '6px',
          height: '6px',
          border: 'none',
          borderRadius: '50%',
          bottom: '-3px'
        }}
      />
    </div>
  );
};

export default IndividNode; 